export { InstagramIcon } from './instagram-icon';
